import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit, signal, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BasketService } from 'src/app/checkout-page/services/basket.service';
import { CATALOG } from 'src/core-lib/misselaineous/boot.tokens';
import { Link } from 'src/core-lib/navigation/models/link.model';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { ImageUtil } from 'src/layout/media/image.util';
import { Overlay } from 'src/layout/overlay/models/overlay.interface';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';
import { ContentCacheUtils, StorageUtil } from 'src/utils/storage.util';
import { IconLink } from '../../models/icon-link.model';
import { Language, Languages, MainConfiguration, MenuConfiguration } from '../../models/main-configuration.model';




// import { BasketReturnModel, ProductCardModel, SearchResponse } from '../../services/client.generated';
declare interface ProductCardModel {}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: []
})
export class HeaderComponent implements OnInit {
    actions: IconLink[];
    languages: Languages;
    currentLanguage: Partial<Language>;
    blockedPages = ['checkoutPage'];

    @ViewChild('overlayDropdown')
    overlayDropdown: TemplateRef<unknown>;
    @ViewChild('overlayMenu')
    overlayMenu: TemplateRef<unknown>;
    @ViewChild('overlayLanguage')
    overlayLanguage: TemplateRef<unknown>;
    @ViewChild('overlayBasket')
    overlayBasket: TemplateRef<unknown>;
    @ViewChild('overlaySearch')
    overlaySearch: TemplateRef<unknown>;

    quantity$: Observable<number>;
    selectedLink$: Observable<string>;
    menu: Partial<MenuConfiguration>;
    system: Partial<MainConfiguration>;
    pageAlias$: Observable<string>;
    basketPageUrl: string;
    logoUrl: string;
    mobileLogoUrl: string;
    isMobile: any;
    logoUrlx2: string;

    constructor(
        private overlayService: OverlayService,
        private route: ActivatedRoute,
        private _detector: ChangeDetectorRef,
        private translateService: TranslateService,
        private basketService: BasketService,
        @Inject(CATALOG)
        public _catalog: string,
    ) {
        this.pageAlias$ = this.route.data.pipe(
            map(p => p?.content?.page?._meta?.alias ?? '')
        );
        this.selectedLink$ = this.overlayService.overlay$.pipe(
            map((o: Overlay<any>) => o?.context?.link)
        );
        this.quantity$ = this.basketService.basket$.pipe(
            map(basket => basket?.quantity > 0 ? basket.quantity : null),
            shareReplay(1),
        );
        this.isMobile = signal<boolean>(window.matchMedia('(max-width: 1400px), screen and (pointer: course)').matches)
    }

    @HostListener('window:resize')
    onSizeChange() {
        this.isMobile.set(window.matchMedia('(max-width: 1400px), screen and (pointer: course)').matches)
    }

    async ngOnInit() {
        const translations = await this.translateService.get(['MENU.SEARCH', 'MENU.BASKET']).toPromise();
        this.basketPageUrl = (ContentCacheUtils.checkout<{ basketPageLink: string }>()).basketPageLink;
        this.system = ContentCacheUtils.system<MainConfiguration>();
        this.menu = ContentCacheUtils.menu<MenuConfiguration>();
        let imgUrl = StorageUtil.get<{ logo: UmbracoImage }>('webshopThemeConfig')?.logo?.imageUrl;
        if (imgUrl != null) {
            let logoTemp = new URL(imgUrl, window.origin);
            if(logoTemp.pathname.endsWith('.svg')) {
                this.logoUrl = logoTemp.href;
                this.logoUrlx2= '';
            } else {
                ImageUtil.queryEntries.forEach(([key, value]) => logoTemp.searchParams.append(key, value))
                logoTemp.searchParams.set('height', '48');
                this.logoUrl = logoTemp.href;
                logoTemp.searchParams.set('height', '96');
                this.logoUrlx2 = logoTemp.href +' 2x, '+this.logoUrl+' 1x';
            }
        } else {
            this.logoUrl = '';
        }
        this.actions = [
            {
                title: translations['MENU.SEARCH'],
                image: 'search',
                hideTitle: false,
                function: () => this.openSearchOverlay()
            },
            {
                title: translations['MENU.BASKET'],
                image: 'basket',
                hideTitle: false,
                // link: this.basketPageUrl,
                function: () => this.openOverlayBasket(),
                count: this.quantity$
            }
        ];
        this._detector.markForCheck();
    }

    openSearchOverlay(): void {
        setTimeout(() => {
            this.overlayService.open({
                template: this.overlaySearch,
                hideBackdrop: false,
                classes: 'search-dropdown'
            })
        }, 10);

    }

    openOverlayMenu() {
        this.overlayService.open({ template: this.overlayMenu });
    }

    openOverlayBasket() {
        this.overlayService.open({ template: this.overlayBasket });
    }

    openDropdown(link: Link) {
        setTimeout(() => {
            this.overlayService.open({
                template: this.overlayDropdown,
                context: {
                    $implicit: link.children,
                    link: link,
                },
                hideBackdrop: false,
                classes: 'menu-dropdown'
            });
        }, 10);
    }

    closeOverlay() {
        if (
            ['menu-dropdown', 'search-dropdown']
                .some(_ => this.overlayService.current()?.classes)
        )
            this.overlayService.close();
    }
}
